// AI_CONTEXT: {
//   "docs": [
//     "epics/202610211834_GBG_group-member-background/tickets/GBG-000-membership-call-dedup-groundwork"
//   ],
//   "purpose": "Page header module: logo and nav links, user links and login state, scroll/hide state, and the membership link check on user-link routes",
//   "version": "1.0.0",
//   "priority": "core",
//   "stability": "stable"
// }
define("Modules/PageHeader", [`Module`, `module`], function (Super, Self) {
	const userLinkRoutes = {
		[`/home/events`]: `wallet`,
		[`/home/media`]: `media`,
		[`/home/wallet`]: `wallet`,

		[`/home`]: `account`,
		[`/home/profile`]: `account`,
		[`/home/orders`]: `account`,
		[`/home/transfers`]: `account`,
		[`/home/invoices`]: `account`,
		[`/home/season-passes`]: `account`,
		[`/home/memberships`]: `memberships`,
		[`/home/account-memberships`]: `account`,
		[`/home/credits`]: `account`,
		[`/home/rewards`]: `account`,
		[`/home/benefits`]: `account`,
		[`/home/payment`]: `account`,
		[`/home/payouts`]: `account`,
		[`/home/shipping`]: `account`,
		[`/home/documents`]: `account`,
		[`/home/settings`]: `account`,
	};

	// the memberships link is re-checked on arriving at one of these, rather than on every navigation
	const membershipsRoutes = [`/home/memberships`, `/home/account-memberships`];

	return Super.inherit({
		namespace: Self.id,
		requires: [`User`, `MembershipsApi`, `ShoppingCart`, `Countdown`, `ReservedSeating`, `System`],
		defaults: {
			desktopBackgroundWhenScrolled: true, // show page header background on scroll for desktop. Mobile always shows background
			hideOnMobileScroll: false, // slide the header off-screen on scroll-down, back on scroll-up (mobile only)
			intersectionContainerId: null,
			leftLinks: [],
			show: true,
			showTixrLogo: true, // whether to insert the Tixr logo
			showAvatar: true,
			showCountdown: false,
			showMobileLogin: false,
			showSearch: false,
			showUserLinks: true,
			transition: `fade`,
			rightLinks: [],

			/**
			 * callbacks: {
			 *    onScrollStateChange: function({ scrolled }) {}
			 *    onHideStateChange: function({ hidden }) {}
			 * }
			 */
		},
		constructor(setup) {
			const { App, Countdown, User, container, data, instances } = this;
			const { location } = document;
			const {
				desktopBackgroundWhenScrolled,
				hideOnMobileScroll,
				intersectionContainerId,
				leftLinks,
				rightLinks,
				showAvatar,
				showCountdown,
				showMobileLogin,
				showSearch,
				showUserLinks,
				showTixrLogo,
			} = setup;
			const links = [];
			let showLanguageMenu = false;

			if (desktopBackgroundWhenScrolled) {
				this.addClass(`desktop-background-when-scrolled`);
			}

			if (showTixrLogo) {
				leftLinks.unshift({
					type: `icon`,
					href: `/`,
					icon: `tixr`,
					customClass: `logo`,
					label: `home`,
				});
				this.addClass(`has-tixr-logo`);
			}

			this.chain(leftLinks)
				.concat(rightLinks)
				.each((link) => {
					this.defaults(link, {
						id: this.uniqueId(),
						action: `customLink`,
						type: `text`,
						customClass: ``,
						mobile: true,
						desktop: true,
						app: true,
						tooltip: null,
					});

					if (this.isFunction(link.handler)) {
						link.href = `#`;
						links.push({
							id: link.id,
							options: link,
							owner: setup.owner,
							handler: link.handler,
						});

						delete link.handler; // avoid functions in this.data
					}
				});

			this.links = links;

			this.assign(data, {
				hiddenOnScroll: false,
				hideOnMobileScroll,
				intersectionContainerId,
				lastChanged: 0,
				leftLinks,
				rightLinks,
				scrolled: false,
				scrollThreshold: 20, // set an initial value, properly calculated below
				showAvatar,
				showCountdown,
				showLanguageMenu,
				showMobileLogin,
				showSearch,
				showUserLinks,
				showTixrLogo,
			});

			this.render();

			this.defer({
				duration: 300,
				then: () => {
					if (this.isElement(this.get(`.blur-gradient`))) {
						this.get(`.blur-gradient`).style.transform = `translateY(0)`;
					}
				},
			});

			Countdown.get({
				fireImmediately: true,
				subscribe: async ({ expiration }) => {
					const { promises } = this;
					const { countdown } = instances;
					const name = `simple-countdown`;
					const target = this.get(`[name="simple-countdown"]`);
					const transition = `fade`;

					if (this.isInt(expiration)) {
						let { countdown: countdownPromise } = promises;
						const timestamp = expiration;

						if (this.isObject(countdown)) {
							countdown.change({ timestamp });
						} else {
							const suffix = null;
							const mode = `bold`;
							const show = true;
							const prefix = null;

							if (countdownPromise === undefined) {
								countdownPromise = this.create({
									namespace: `Modules/SimpleCountdown`,
									setup: {
										name,
										mode,
										prefix,
										timestamp,
										show,
										suffix,
									},
								});
							} else {
								const countdown = await countdownPromise;
								countdown.change({ timestamp });
								this.show({ target, transition });
							}
						}
					} else {
						this.hide({ target, transition });
					}
				},
			});

			if (showUserLinks) {
				this.addClass(`display-user-links`);
			}
			if (!showUserLinks) {
				this.removeClass(`display-user-links`);
				this.hide({ target: this.get(`.user-links`) });
			}

			if (leftLinks.length === 0) {
				this.hide({ selector: `.left-links` });
			}
			if (rightLinks.length === 0) {
				this.hide({ selector: `.right-links` });
			}

			if (this.isString(intersectionContainerId, 1)) {
				this.setIntersectionObserver();
			} else {
				App.onScroll(({ scrollTop }) => {
					this.checkScroll(scrollTop);
				});
			}

			if (hideOnMobileScroll) {
				App.onScroll(({ scrollDelta }) => {
					this.checkHideOnScroll(scrollDelta);
				});
			}

			if (setup.showAvatar) {
				this.create({
					namespace: `Modules/MenuDrawer`,
					setup: {
						container: this.get(`[name="page-header-menu"]`, container),
					},
				});
			}

			data.pathname = location.pathname;
			this.checkHrefs();

			App.onPageChange((details) => {
				const previousPathname = data.pathname;

				data.pathname = details.pathname;
				this.checkHrefs();

				// /home/* navigation is a page *update* - this module isn't rebuilt, so the memberships
				// link has to be re-checked here rather than only when the user first resolves. Only on
				// arriving at a memberships page, so browsing elsewhere never asks
				if (previousPathname !== details.pathname && this.includes(membershipsRoutes, details.pathname)) {
					this.checkMemberships();
				}
			});

			User.get({
				subscribe: true,
				then: (user) => {
					const isGuestUser = User.isGuestUser();

					if (isGuestUser) {
						this.handleLoggedOut();
					} else {
						this.handleLoggedIn(user);
					}
				},
				fail: this.handleLoggedOut,
			});
		},

		api: {
			checkHrefs: {
				value(evt) {
					this.removeClass(`selected`, this.select(`.user-links .selected`));

					// highlight link based on pathname
					const section = userLinkRoutes[window.location.pathname];
					if (section) {
						this.addClass(`selected`, this.get(`#${section}`));
					}
				},
			},

			checkScroll: {
				value(scrollTop) {
					const { data } = this;
					const { scrolled, scrollThreshold } = this.data;

					if (scrollTop > scrollThreshold) {
						if (!scrolled) {
							this.addClass(`scrolled`);
							data.scrolled = true;
						}
					} else {
						if (scrolled) {
							this.removeClass(`scrolled`);
							data.scrolled = false;
						}
					}
				},
			},

			checkHideOnScroll: {
				value(scrollDelta) {
					const { System, data } = this;
					const { intersectionContainerId, scrolled } = data;
					const isMobile = System.get().breakpoint === `mobile`;
					// while intersectionContainerId is in use, don't slide the header away until
					// scroll has passed the intersection threshold (data.scrolled)
					const canHide = !this.isString(intersectionContainerId, 1) || scrolled;
					// ignore tiny/noisy deltas (e.g. a scroll-anchoring correction) so the header
					// doesn't flicker between shown/hidden
					const deadzone = 10;

					if (!isMobile || !canHide) {
						this.setHiddenOnScroll(false);
					} else if (scrollDelta < -deadzone) {
						this.setHiddenOnScroll(true);
					} else if (scrollDelta > deadzone) {
						this.setHiddenOnScroll(false);
					}
				},
			},

			setHiddenOnScroll: {
				value(hidden) {
					const { callbacks, data } = this;

					if (hidden === data.hiddenOnScroll) {
						return;
					}

					if (hidden) {
						this.addClass(`hidden-on-scroll`);
					} else {
						this.removeClass(`hidden-on-scroll`);
					}

					data.hiddenOnScroll = hidden;

					if (this.isFunction(callbacks.onHideStateChange)) {
						callbacks.onHideStateChange({ hidden });
					}
				},
			},

			handleLoggedIn: {
				value(user) {
					const { showUserLinks } = this.data;
					const userLinks = this.get(`.user-links`);

					if (showUserLinks && this.isObject(userLinks)) {
						this.show({ target: userLinks, transition: `fade` });
					}

					this.hide({ target: this.get(`.login`) });

					if (showUserLinks && userLinkRoutes[window.location.pathname]) {
						this.checkMemberships();
					}
				},
			},

			handleLoggedOut: {
				value() {
					const userLinks = this.get(`.user-links`);

					if (this.isObject(userLinks)) {
						this.hide({ target: userLinks, transition: `fade` });
					}

					this.show({ target: this.get(`.login`) });

					const membershipsLink = this.get(`[name="memberships-link"]`);

					if (this.isElement(membershipsLink)) {
						this.hide({ target: membershipsLink });
					}
				},
			},

			/**
			 * The memberships link only belongs in the nav while the fan holds a membership that hasn't
			 * ENDED, so it starts hidden in the template and is revealed once that's confirmed.
			 * @method checkMemberships
			 */
			checkMemberships: {
				async value() {
					const { MembershipsApi } = this;
					const membershipsLink = this.get(`[name="memberships-link"]`);

					if (!this.isElement(membershipsLink)) {
						return;
					}

					const hasMemberships = await MembershipsApi.hasMemberships().catch(() => false);

					if (!this.alive) {
						return; // navigated away while the check was in flight
					}

					if (hasMemberships) {
						this.show({ target: membershipsLink });
					} else {
						this.hide({ target: membershipsLink });
					}
				},
			},

			/**
			 * Rebuild the IntersectionObserver against whatever element currently carries
			 * `intersectionContainerId`. Called internally on resize, and public so an owner
			 * that replaces the element holding that id can re-point the observer - it resolves
			 * the target by id at call time, so an existing observer would otherwise stay bound
			 * to the detached node and never report a scroll again.
			 */
			setIntersectionObserver: {
				public: true,
				value() {
					const { DOM, callbacks, data, elements, instances } = this;
					const { intersectionContainerId } = data;

					this.destroyIntersectionObserver();

					// Generation counter pattern to prevent stale observer callbacks after a reset
					const generation = (instances.observerGeneration || 0) + 1;
					instances.observerGeneration = generation;

					const intersectionContainer = document.getElementById(intersectionContainerId);
					const viewportDimensions = DOM.getDimensions(document.body);
					const containerDimensions = DOM.getDimensions();
					const scrollThreshold = containerDimensions.height - viewportDimensions.height;

					const { IntersectionObserver } = window;
					const handler = ([e]) => {
						// Solves the problem when setIntersectionObserver is called again (e.g. on
						// resize when toggling desktop/mobile view), calls destroyIntersectionObserver
						// first but if the old observer's handler fires asynchronously after the new
						// one is set up, double-firing
						if (instances.observerGeneration !== generation) {
							return;
						}

						if (e.isIntersecting) {
							// cancel any pending "leaving scrolled zone" debounce below
							instances.leaveGeneration = (instances.leaveGeneration || 0) + 1;

							this.addClass(`scrolled`);
							data.scrolled = true;
							if (this.isFunction(callbacks.onScrollStateChange)) {
								callbacks.onScrollStateChange({ scrolled: true });
							}
						} else if (e.boundingClientRect.bottom <= 0) {
							// the target has scrolled entirely above the viewport - the user has
							// scrolled well past it (e.g. past the end of a sticky container),
							// not back up toward the top, so keep acting as if still intersecting
							return;
						} else {
							// debounce leaving the scrolled zone: geometry changes from the
							// scrolled/header-hidden CSS transitions can momentarily flip
							// isIntersecting, which without this would bounce the header/padding
							// states back and forth
							const leaveGeneration = (instances.leaveGeneration || 0) + 1;
							instances.leaveGeneration = leaveGeneration;

							this.defer({
								duration: 150,
								then: () => {
									if (instances.observerGeneration !== generation || instances.leaveGeneration !== leaveGeneration) {
										return;
									}

									this.removeClass(`scrolled`);
									data.scrolled = false;
									if (this.isFunction(callbacks.onScrollStateChange)) {
										callbacks.onScrollStateChange({ scrolled: false });
									}

									// back above the intersection threshold: always reveal the header
									this.setHiddenOnScroll(false);
								},
							});
						}
					};
					const options = {
						threshold: [0, 0.25, 0.5, 0.75, 1],
						rootMargin: `0px 0px ${scrollThreshold}px 0px`,
					};
					const observer = new IntersectionObserver(handler, options);

					observer.observe(intersectionContainer);

					elements.intersectionContainer = intersectionContainer;
					instances.observer = observer;
				},
			},

			destroyIntersectionObserver: {
				value() {
					const { elements, instances } = this;
					const { intersectionContainer } = elements;
					const { observer } = instances;

					if (this.isElement(intersectionContainer)) {
						observer.disconnect();
					}
				},
			},
		},

		destructor(options) {
			this.destroyIntersectionObserver();
		},

		listeners: [
			{
				event: `click`,
				filter: `[action]`,
				handler(evt) {
					const { App, Time, data } = this;

					var target = evt.currentTarget,
						action = target.getAttribute(`action`),
						actions = this.select(`a[action]`),
						avatar = this.get(`.avatar`),
						link;

					this.each(actions, (action) => {
						this.removeClass(`selected`, action);
					});

					this.addClass(`selected`, target);

					if (this.isElement(avatar)) {
						this.removeClass(`hover`, avatar);
						data.lastChanged = Time.getTime();
					}

					switch (action) {
						case `custom-link`:
							link = this.find(this.links, {
								id: target.getAttribute(`id`),
							});

							if (!this.isObject(link)) {
								throw new Error(`Modules/PageHeader: No handler found for link`);
							}

							link.handler.call(link.owner, evt);
							break;

						case `search`:
							return App.loadOverlay({ type: `SiteSearch` }); // returning, no break

						case `close-menu`:
							this.removeClass(`menu-open`);
							break;

						case `login`:
							this.App.loadOverlay({
								type: `LogInOverlay`,
								replace: true,
								setup: {
									allowSignUp: true,
								},
								done: true,
							});
					}
				},
			},
			{
				event: `resize`,
				target: window,
				matchContainer: false,
				debounce: 200,
				handler() {
					const { System, data } = this;
					const { hideOnMobileScroll, intersectionContainerId } = data;
					const isMobile = System.get().breakpoint === `mobile`;

					if (this.isString(intersectionContainerId, 1)) {
						this.setIntersectionObserver();
					}

					if (hideOnMobileScroll && !isMobile) {
						this.setHiddenOnScroll(false);
					}
				},
			},
		],
	});
});

define("Modules/PageHeader.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/PageHeader/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <li class=\""
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"mobile") : depth0),{"name":"unless","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":112},"end":{"line":1,"column":152}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"desktop") : depth0),{"name":"unless","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":152},"end":{"line":1,"column":195}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"app") : depth0),{"name":"unless","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":195},"end":{"line":1,"column":230}}})) != null ? stack1 : "")
    + "\"> "
    + ((stack1 = lookupProperty(helpers,"compare").call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"image",{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(16, data, 0),"data":data,"loc":{"start":{"line":1,"column":233},"end":{"line":1,"column":1229}}})) != null ? stack1 : "")
    + " </li> ";
},"2":function(container,depth0,helpers,partials,data) {
    return "hide-mobile";
},"4":function(container,depth0,helpers,partials,data) {
    return " hide-desktop";
},"6":function(container,depth0,helpers,partials,data) {
    return " hide-app";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"src") : depth0),{"name":"if","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":259},"end":{"line":1,"column":542}}})) != null ? stack1 : "")
    + " ";
},"9":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" role=\"button\" class=\"image\" "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"alt") : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":318},"end":{"line":1,"column":357}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":357},"end":{"line":1,"column":411}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":412},"end":{"line":1,"column":497}}})) != null ? stack1 : "")
    + "> <img src=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"src") : depth0), depth0))
    + "\" alt=\"logo\"> </a> ";
},"10":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " aria-label=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"alt") : depth0), depth0))
    + "\"";
},"12":function(container,depth0,helpers,partials,data) {
    return " action=\"custom-link\"";
},"14":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " data-tooltip-text=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"tooltip") : depth0), depth0))
    + "\" data-tooltip-position=\"bottom\"";
},"16":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"compare").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"icon",{"name":"compare","hash":{},"fn":container.program(17, data, 0),"inverse":container.program(20, data, 0),"data":data,"loc":{"start":{"line":1,"column":543},"end":{"line":1,"column":1217}}})) != null ? stack1 : "");
},"17":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" role=\"button\" href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" aria-label=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":640},"end":{"line":1,"column":694}}})) != null ? stack1 : "")
    + " class=\"type-icon "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"customClass") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":712},"end":{"line":1,"column":753}}})) != null ? stack1 : "")
    + "\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":754},"end":{"line":1,"column":839}}})) != null ? stack1 : "")
    + "> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":841},"end":{"line":1,"column":857}}}))
    + " </a> ";
},"18":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"customClass") : depth0), depth0));
},"20":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"compare").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"icon-label",{"name":"compare","hash":{},"fn":container.program(21, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":863},"end":{"line":1,"column":1217}}})) != null ? stack1 : "");
},"21":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" aria-label=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":952},"end":{"line":1,"column":1006}}})) != null ? stack1 : "")
    + " class=\"type-icon-label "
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"customClass") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1030},"end":{"line":1,"column":1071}}})) != null ? stack1 : "")
    + "\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":1072},"end":{"line":1,"column":1157}}})) != null ? stack1 : "")
    + "> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1159},"end":{"line":1,"column":1175}}}))
    + "<span class=\"label\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0))
    + "</span> </a> ";
},"23":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <li class=\""
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"mobile") : depth0),{"name":"unless","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2190},"end":{"line":1,"column":2231}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"desktop") : depth0),{"name":"unless","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2231},"end":{"line":1,"column":2274}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"app") : depth0),{"name":"unless","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2274},"end":{"line":1,"column":2309}}})) != null ? stack1 : "")
    + "\"> "
    + ((stack1 = lookupProperty(helpers,"compare").call(alias1,(depth0 != null ? lookupProperty(depth0,"type") : depth0),"button",{"name":"compare","hash":{},"fn":container.program(30, data, 0),"inverse":container.program(32, data, 0),"data":data,"loc":{"start":{"line":1,"column":2312},"end":{"line":1,"column":3095}}})) != null ? stack1 : "")
    + " </li> ";
},"24":function(container,depth0,helpers,partials,data) {
    return "hide-mobile ";
},"26":function(container,depth0,helpers,partials,data) {
    return "hide-desktop ";
},"28":function(container,depth0,helpers,partials,data) {
    return "hide-app ";
},"30":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" role=\"button\" href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" aria-label=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"ariaLabel") : depth0), depth0))
    + "\" class=\"button ux4 small\" theme=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\""
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2453},"end":{"line":1,"column":2507}}})) != null ? stack1 : "")
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2507},"end":{"line":1,"column":2592}}})) != null ? stack1 : "")
    + "> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":2594},"end":{"line":1,"column":2610}}}))
    + "<span class=\"button-label hide-mobile\">"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"label") : depth0), depth0)) != null ? stack1 : "")
    + "</span> </a> ";
},"32":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"compare").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"type") : depth0),"icon",{"name":"compare","hash":{},"fn":container.program(33, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2673},"end":{"line":1,"column":3083}}})) != null ? stack1 : "");
},"33":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" role=\"button\" href=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"href") : depth0), depth0))
    + "\" aria-label=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"ariaLabel") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"compare").call(alias3,(depth0 != null ? lookupProperty(depth0,"href") : depth0),"#",{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2774},"end":{"line":1,"column":2828}}})) != null ? stack1 : "")
    + " class=\"type-icon button ux4 nav-link large"
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"customClass") : depth0),{"name":"if","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2871},"end":{"line":1,"column":2912}}})) != null ? stack1 : "")
    + "\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"tooltip") : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2913},"end":{"line":1,"column":2998}}})) != null ? stack1 : "")
    + " theme=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias3,(depth0 != null ? lookupProperty(depth0,"theme") : depth0),{"name":"if","hash":{},"fn":container.program(34, data, 0),"inverse":container.program(36, data, 0),"data":data,"loc":{"start":{"line":1,"column":3006},"end":{"line":1,"column":3058}}})) != null ? stack1 : "")
    + "\"> "
    + alias2(lookupProperty(helpers,"getIcon").call(alias3,(depth0 != null ? lookupProperty(depth0,"icon") : depth0),{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":3061},"end":{"line":1,"column":3077}}}))
    + " </a> ";
},"34":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0));
},"36":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (data && lookupProperty(data,"root"))) && lookupProperty(stack1,"theme")), depth0));
},"38":function(container,depth0,helpers,partials,data) {
    var alias1=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <li> <a role=\"button\" href=\"#\" aria-label=\"search\" action=\"search\" class=\"type-icon button ux4 nav-link large\" theme=\""
    + alias1(container.lambda((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\">"
    + alias1(lookupProperty(helpers,"getIcon").call(depth0 != null ? depth0 : (container.nullContext || {}),"magnifying-glass",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":3260},"end":{"line":1,"column":3290}}}))
    + "</a> </li> ";
},"40":function(container,depth0,helpers,partials,data) {
    return " hide-mobile";
},"42":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <li name=\"page-header-menu\" theme=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\"></li> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<nav class=\"content\" aria-label=\"Main navigation\"> <ul class=\"links links-left\"> "
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"leftLinks") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":81},"end":{"line":1,"column":1245}}})) != null ? stack1 : "")
    + " </ul> <ul class=\"links links-center hide-mobile user-links\"> <li> <a id=\"wallet\" href=\"/home/events\" aria-label=\"my wallet\" class=\"nav-link\" theme=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\"> "
    + alias3(lookupProperty(helpers,"getIcon").call(alias1,"wallet-new",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1406},"end":{"line":1,"column":1430}}}))
    + "<span class=\"button-label\">Wallet</span> </a> </li> <li name=\"memberships-link\" style=\"display: none;\"> <a id=\"memberships\" href=\"/home/memberships\" aria-label=\"my memberships\" class=\"nav-link\" theme=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\"> "
    + alias3(lookupProperty(helpers,"getIcon").call(alias1,"membership-card",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1643},"end":{"line":1,"column":1672}}}))
    + "<span class=\"button-label\">Memberships</span> </a> </li> <li> <a id=\"media\" href=\"/home/media\" aria-label=\"my media\" class=\"nav-link\" theme=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\"> "
    + alias3(lookupProperty(helpers,"getIcon").call(alias1,"play-circle-open",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":1825},"end":{"line":1,"column":1855}}}))
    + "<span class=\"button-label\">Media</span> </a> </li> <li> <a id=\"account\" href=\"/home\" aria-label=\"my account\" class=\"nav-link\" theme=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\"> "
    + alias3(lookupProperty(helpers,"getIcon").call(alias1,"profile",{"name":"getIcon","hash":{},"data":data,"loc":{"start":{"line":1,"column":2000},"end":{"line":1,"column":2021}}}))
    + "<span class=\"button-label\">Account</span> </a> </li> </ul> <ul class=\"links links-right\"> <li> <div name=\"simple-countdown\"></div> </li> "
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,(depth0 != null ? lookupProperty(depth0,"rightLinks") : depth0),{"name":"each","hash":{},"fn":container.program(23, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":2158},"end":{"line":1,"column":3111}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showSearch") : depth0),{"name":"if","hash":{},"fn":container.program(38, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":3112},"end":{"line":1,"column":3308}}})) != null ? stack1 : "")
    + " <li class=\"login"
    + ((stack1 = lookupProperty(helpers,"unless").call(alias1,(depth0 != null ? lookupProperty(depth0,"showLoginOnMobile") : depth0),{"name":"unless","hash":{},"fn":container.program(40, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":3325},"end":{"line":1,"column":3377}}})) != null ? stack1 : "")
    + "\"> <a href=\"#\" action=\"login\" class=\"button ux4 primary small\" theme=\""
    + alias3(alias2((depth0 != null ? lookupProperty(depth0,"theme") : depth0), depth0))
    + "\">Log In</a> </li> "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"showAvatar") : depth0),{"name":"if","hash":{},"fn":container.program(42, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":3475},"end":{"line":1,"column":3553}}})) != null ? stack1 : "")
    + " </ul> </nav>";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=PageHeader.js.map